
import React from "react";
import PasswordRecovery from "@/pages/PasswordRecovery";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Discover from "@/pages/Discover";
import Matches from "@/pages/Matches";
import Messages from "@/pages/Messages";
import Forum from "@/pages/Forum";
import Profile from "@/pages/Profile";
import Premium from "@/pages/Premium";
import WhoLikedMe from "@/pages/WhoLikedMe";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import VerifyEmail from "@/pages/VerifyEmail";
import Awareness from "@/pages/Awareness";
import Help from "@/pages/Help";
import Health from "@/pages/Health";
import HealthTopic from "@/pages/HealthTopic";
import PaymentPaypalSuccess from "@/pages/PaymentPaypalSuccess";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#D95D39] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();

  // Synchronous check for session_id in fragment (OAuth callback)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/forgot-password" element={<PasswordRecovery key="forgot" />} />
      <Route path="/reset-password" element={<PasswordRecovery key="reset" />} />
      <Route path="/" element={<Landing />} />
      <Route path="/discover" element={<ProtectedRoute><Discover /></ProtectedRoute>} />
      <Route path="/matches" element={<ProtectedRoute><Matches /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/messages/:matchId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/forum" element={<ProtectedRoute><Forum /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/premium" element={<ProtectedRoute><Premium /></ProtectedRoute>} />
      <Route path="/likes" element={<ProtectedRoute><WhoLikedMe /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/paypal/success" element={<ProtectedRoute><PaymentPaypalSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
      <Route path="/verify-email" element={<ProtectedRoute><VerifyEmail /></ProtectedRoute>} />
      <Route path="/verify-email/:token" element={<VerifyEmail />} />
      <Route path="/awareness" element={<Awareness />} />
      <Route path="/help" element={<Help />} />
      <Route path="/health" element={<Health />} />
      <Route path="/health/:slug" element={<HealthTopic />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
